export default __webpack_public_path__ + "static/media/Marketing.866b8da0.png";